module.exports = __webpack_public_path__ + "img/british-indian-ocean-territory.1ad24c62.png";